/* eslint-disable @typescript-eslint/indent */
import { loading } from './../../../redux/actions/loading';
import { ThunkAction } from 'redux-thunk';
import { State as LoginState } from '@telstra-connect/login';
import {
    loadDDAgreementStart,
    loadDDAgreementSuccess,
    loadDDAgreementError
} from '../actions/load-dd-agreement';
import { IDDAgreementResponse } from '../state/dd-agreement';
import { Http } from '@telstra-connect/utils';
import { getRequestIdForAlerts } from '@telstra-connect/utils/http/common/headers';
import api from '../version';

export function loadExistingDDAgreementMethod(cidn: string, accountId: string):
    ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch, getState) => {
        const srcSystem = sessionStorage.getItem('TC:billing:sourceSystem')
        const system = ['FLEXCAB', 'MICA'].includes(srcSystem) ? srcSystem : 'B2B_AgileBiller'
        dispatch(loadDDAgreementStart());
        const appendHeader = Http.get<IDDAgreementResponse>({
            url: `/billing/${api.version}/account/`
                + `${accountId}/checkExistingDDAgreement?system=${system}`,
            customHeaders: {
                'company-id': cidn,
                'request-id': getRequestIdForAlerts(cidn)
            },
            state: getState()
        })
        return appendHeader.then((result: IDDAgreementResponse) => {
            const response: IDDAgreementResponse = result;
            dispatch(loadDDAgreementSuccess(response));
            dispatch(loading(false))
        })
            .catch((error) => {
                dispatch(loadDDAgreementError('Error loading debit card agreement details.', error.code));
            });
    };
}
